import { __rest } from "tslib";
import React, { useState } from 'react';
import PreviewContent from '@web-common/components/UI/emailPreview/preview';
const HOCEditorPreview = (Component) => {
    const EditorPreview = (props) => {
        const { ref } = props, rest = __rest(props, ["ref"]);
        const [previewContent, setPreviewContent] = useState(['', '']);
        const previewAction = (editor) => {
            if (!editor)
                return;
            const html = editor.getContent();
            const content = `${html}`;
            let previewContent = [content, content];
            setPreviewContent(previewContent);
        };
        return (React.createElement(React.Fragment, null,
            React.createElement(Component, Object.assign({}, rest, { ref: ref, previewAction: previewAction })),
            React.createElement(PreviewContent, { content: previewContent, onCancel: () => setPreviewContent(['', '']) })));
    };
    return React.forwardRef((props, ref) => React.createElement(EditorPreview, Object.assign({}, props, { ref: ref })));
};
export default HOCEditorPreview;
